/*
 * @Author: your name
 * @Date: 2021-06-08 20:32:29
 * @LastEditTime: 2026-04-13 10:12:23
 * @LastEditors: zl21 602659667@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/page/order.config.js
 */
export default {
  SG_B_EXTRACT_ORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/omniChannel/takeTheir.vue'
    ),
    labelName: '全渠道自提单'
  },
  SCANINFOC: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/omniChannel/refundIn.vue'
    ),
    labelName: '全渠道退货扫描'
  },
  SG_B_SEND_ORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/omniChannel/shipOrder.vue'
    ),
    labelName: '全渠道发货单'
  },
  CUS_OC_B_RETURN_ORDER_ALL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/omniChannel/returnOrder.vue'
      ),
    labelName: '全渠道退货单详情',
  },
  OC_B_RETURN_ORDER_ALL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/omniChannel/returnOrder.vue'
      ),
    labelName: '全渠道退货单详情',
  },
  CUS_OC_B_ORDER_ALL: {
    // 路由key与主表表名一致时，定制单对象的返回会导致列表的查询条件被清空或其它bug
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/omniChannel/order.vue'
      ),
    labelName: '全渠道订单详情',
  },
  OC_B_ORDER_ALL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/omniChannel/order.vue'
      ),
    labelName: '全渠道订单详情',
  },
  ORDERMANAGER_TB: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/tbOrderManager/index.vue'
    ),
  },
  OCBVIPCOMRETURNPOITEM: { // 唯品会退货单 - 条码明细Tab
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/skuDetail.vue'
    ),
    isList: false,
  },
  OC_B_ORDER_VIRTUAL_TABLE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/orderManager/orderAddOrCopy.vue'
    ),
    labelName: '订单新增',
    isList: false,
  },
  OC_B_ORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returnOrder/orderManageDetails.vue'
    ),
    labelName: '订单详情',
    isList: false
  },
  // 订单中心-详情
  ORDERMANAGEDETAIL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returnOrder/orderManageDetails.vue'
    ),
  },
  RETURNDETAILS: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returnOrder/returnGoodsOrderDetails.vue'
    ),
  },
  // 订单中心-扫描入库
  SCANIN: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/scanIn2/index.vue'
      // 'allpages/orderCenter/scanIn/scanIn.vue'
    ),
  },
  // 订单中心-列表
  ORDERMANAGER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/orderManager/orderManager.vue'
    ),
    // component: orderManager,
    labelName: $it('pL.retail_shipping_order')
  },
  SG_B_ITEM_DISTRIBUTION: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/allocation/index.vue'
    ),
    labelName: '配货单编辑'
  },
  CUS_SG_B_ITEM_DISTRIBUTION: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/allocation/index.vue'
    ),
    labelName: '配货单编辑'
  },
  OC_B_RETURN_ORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/orderManager/orderManager.vue'
    ),
    labelName: $it('pL.a1')
  },
  // 订单中心-列表-拆分订单
  MANUAL_SPLIT: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/orderManager/splitOrder.vue'
    ),
    // component: splitOrder,
  },
  SPLITORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/orderManager/splitOrder.vue'
    ),
  },
  // 订单中心-新增
  ORDERMANAGEADD: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/orderManageAdd/orderManageAdd.vue'
    ),
    // component: orderManageAdd,
  },
  // 订单中心-退换货单详情
  RETURNGOOD: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnGoodObject.vue'
    ),
    // component: returnGood,
    labelName: $it('menu.b7'), //退货单详情
  },
  // 订单中心-退换货单-列表
  RETURNGOODLIST: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnGoodList.vue'
    ),
    // component: returnGoodList,
  },
  // // 订单中心-退货入库-列表
  RETURNSTOREAGELIST: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/returnStoreageList.vue'
    ),
    labelName: '退货入库结果单', // 退货入库结果单
    // component: returnStorageList,
  },
  RETURN_STOREAGE_ANONYMOUS_LIST: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/returnStoreageList.vue'
    ),
    labelName: '无名件入库结果单', // 无名件入库结果单
  },
  // // 订单中心-退货入库-新增 订单中心-退货入库-详情
  RETURNTREASURYADD: {
    // 退货入库结果单-单对象
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/returnTreasuryAdd.vue'
    ),
  },
  RETURNTREASURYADD_ANONYMOUS: {
    // 无名件入库结果单-单对象
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/returnTreasuryAdd.vue'
      ),
  },
  REFUNDAFTERSHIPMENT: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/refundAfterShipmentTwo.vue'
    ),
    // component: refundAfterShipment,
    labelName: $it('menu.aw'), // 已发货退款单编辑
  },
  EXTRAREFUND: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/refundAfterShipmentOne.vue'
    ),
    // component: refundAfterShipment,
    labelName: $it('menu.ax'), // 额外退款编辑
  },
  MANUALMATCHING: {
    // 退货入库-手工匹配
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/manualMatching.vue'
    ),
  },
  WARNSENDMATCHING: {
    // 退货入库-错发匹配
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/manualMatching.vue'
    ),
  },
  MANUALMATCHING_ANONYMOUS: {
    // 无名件入库-手工匹配
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/manualMatching.vue'
    ),
  },
  WARNSENDMATCHING_ANONYMOUS: {
    // 无名件入库-错发匹配
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnStoreage/manualMatching.vue'
    ),
  },
  DISTRIBUTIONORDERLIST: {
    // component: distributionOrderList,
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/vipJit/distributionOrderList.vue'
    ),
  },
  SPLITDISTRIBUTIONORDER: {
    // JIT配货单-换吊牌
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/distribution/splitDistributionOrder.vue'
    ),
    labelName: $it('menu.ay'), // JIT配货单-换吊牌
  },
  //退货入库半定制
  MATCHINGDETAILS: { //_/views/pages/orderCenter/matchingDetails.vue
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/matchingDetails.vue'
    ),
  },
  // 退换货单新增
  OC_B_RETURN_ORDER_VIRTUAL_TABLE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returnOrder/returnOrderAdd.vue'
    ),
    labelName: $it('menu.az'), // 退换货新增
  },
  // 额外退款单
  E_PRODUCT_DETAILS: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/extraRefund/productDetails.vue'
    ),
  },
  // 发货前退款单
  OC_B_REFUND_ORDER_SENT: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnGoods.vue'
    ),
  },
  OC_B_REFUND_ORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/returnGoods.vue'
    ),
  },
  ORDERDETAIL2: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/orderManageDetail/orderDetail/halfOrderDetail.vue'
    )
  },
  NAIKAINFO: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/NAIKAINFO.vue'
    )
  },

  // pos背景图片设置
  BACKGROUNDURLSET: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/returngood/backgroundUrlSet.vue'),
    labelName: 'pos背景图片设置',
  },
  // 营业指标明细(天)
  targetDetailToSalers: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/retail/targetDetailToSalers.vue'
    ),
  },
  // 营业指标明细(店员)
  targetDetailToDays: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterPage' */
      'allpages/orderCenter/retail/targetDetailToDays.vue'
    ),
  },
};
